import React, { useState, useEffect } from 'react';

function DateInput() {
  const [dateValue, setDateValue] = useState('');
  const [isDateInput, setIsDateInput] = useState(false);

  // Function to format the date as dd-MMM-yyyy
  const formatDate = (date) => {
    let day = date.getDate().toString().padStart(2, '0');
    let month = date.toLocaleString('default', { month: 'short' });
    let year = date.getFullYear().toString();
    return `${day}-${month}-${year}`;
  };

  // Handle date change
  const handleDateChange = (e) => {
    let date = new Date(e.target.value);
    if (!isNaN(date)) {
      setDateValue(formatDate(date));
      setIsDateInput(false); // Switch back to text to display the formatted date
    }
  };

  // Handle input focus to allow date selection again
  const handleFocus = () => {
    setIsDateInput(true); // Switch to date input mode on focus
  };

  // Initialize today's date as the default value
  useEffect(() => {
    let today = new Date();
    setDateValue(formatDate(today));
  }, []);

  return (
    <input
      type={isDateInput ? 'date' : 'text'}
      value={dateValue}
      onChange={handleDateChange}
      onFocus={handleFocus}
      readOnly={!isDateInput} // Prevent manual input in text mode
    />
  );
}

export default DateInput;
